import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function NotificationPagination({
  page,
  totalPages,
  perPage,
  totalItems,
  onPageChange,
  onPerPageChange,
}) {
  if (totalPages <= 1 && totalItems <= Number(perPage)) return null;

  return (
    <section className="flex flex-col gap-3 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm font-bold text-slate-500 dark:text-white/50">
        {totalItems} notification{totalItems > 1 ? "s" : ""} trouvée
        {totalItems > 1 ? "s" : ""}
      </p>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <select
          value={perPage}
          onChange={(event) => onPerPageChange("perPage", Number(event.target.value))}
          className="h-11 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-xs font-bold text-slate-700 outline-none dark:border-white/10 dark:bg-slate-950 dark:text-white"
        >
          <option value={12}>12 / page</option>
          <option value={25}>25 / page</option>
          <option value={50}>50 / page</option>
        </select>

        <div className="grid grid-cols-[44px_1fr_44px] items-center gap-2">
          <button
            type="button"
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
            className="inline-flex h-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
          >
            <FaChevronLeft />
          </button>

          <span className="text-center text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            {page} / {totalPages}
          </span>

          <button
            type="button"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            className="inline-flex h-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
}

export default NotificationPagination;